<div class="selected-options">
  <ng-content></ng-content>
</div>
